import * as $runtime from "../runtime.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Effect$dConsole from "../Effect.Console/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dInternal$dStringify from "../Foreign.Internal.Stringify/index.js";
import * as Foreign$dJSON from "../Foreign.JSON/index.js";
const $Storage = (_1, _2) => ({tag: "Storage", _1, _2});
const show = /* #__PURE__ */ (() => Data$dList$dTypes.showNonEmptyList(Foreign.showForeignError).show)();
const Key = x => x;
const Storage = value0 => value1 => $Storage(value0, value1);
const newtypeKey_ = {Coercible0: () => {}};
const setItem = v => v._2;
const setJSONItem = dictEncode => storage => key => value => storage._2(key)(Foreign$dInternal$dStringify.unsafeStringify(dictEncode.encode(value)));
const getItem = v => v._1;
const getJSONItem = dictDecode => {
  const decodeJSON = Foreign$dJSON.decodeJSONWith(dictDecode.decode);
  return storage => key => {
    const $0 = storage._1(key);
    return () => {
      const nullable_json = $0();
      if (nullable_json.tag === "Just") {
        const v = decodeJSON(nullable_json._1);
        if (v.tag === "Left") {
          Effect$dConsole.log("Error decoding localStorage." + key + "\n - Error: " + show(v._1) + "\n - Value: " + nullable_json._1)();
          return Data$dMaybe.Nothing;
        }
        if (v.tag === "Right") { return Data$dMaybe.$Maybe("Just", v._1); }
        $runtime.fail();
      }
      if (nullable_json.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    };
  };
};
export {$Storage, Key, Storage, getItem, getJSONItem, newtypeKey_, setItem, setJSONItem, show};
